"use client";

import { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MeetTheTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const [scrollY, setScrollY] = useState(0);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [dragOffset, setDragOffset] = useState({
    x: 0,
    y: 0
  });
  const [initialMousePos, setInitialMousePos] = useState({
    x: 0,
    y: 0
  });
  const [finalPositions, setFinalPositions] = useState([{
    x: 0,
    y: 0
  }, {
    x: 0,
    y: 0
  }, {
    x: 0,
    y: 0
  }]);
  useEffect(() => {
    const handleScroll = () => {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return;
      }
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    if (draggedIndex === null) return;
    const handleMouseMove = (e: MouseEvent) => {
      const deltaX = e.clientX - initialMousePos.x;
      const deltaY = e.clientY - initialMousePos.y;
      setDragOffset({
        x: deltaX,
        y: deltaY
      });
    };
    const handleMouseUp = () => {
      if (draggedIndex !== null) {
        setFinalPositions(prev => {
          const updated = [...prev];
          updated[draggedIndex] = {
            x: prev[draggedIndex].x + dragOffset.x,
            y: prev[draggedIndex].y + dragOffset.y
          };
          return updated;
        });
      }
      setDraggedIndex(null);
      setDragOffset({
        x: 0,
        y: 0
      });
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [draggedIndex, initialMousePos, dragOffset]);
  const team = [{
    id: 1,
    name: "Luis Scheker Sr.",
    role: "Founder & CEO",
    image: "https://hardy-weasel-1.10web.cloud/wp-content/uploads/2025/12/IMG_1902-2-scaled.jpg",
    parallaxFactor: 0.08
  }, {
    id: 3,
    name: "Luis Abraham",
    role: "Treasurer/Partner",
    image: "https://hardy-weasel-1.10web.cloud/wp-content/uploads/2025/12/IMG_8336-scaled.jpg",
    parallaxFactor: -0.05
  }, {
    id: 2,
    name: "Luis Jr.",
    role: "Manager/Partner",
    image: "https://hardy-weasel-1.10web.cloud/wp-content/uploads/2025/12/IMG_1483-preview-scaled.jpg",
    parallaxFactor: 0.05
  }];
  const handleMouseDown = (index: number, e: React.MouseEvent) => {
    e.preventDefault();
    setDraggedIndex(index);
    setInitialMousePos({
      x: e.clientX,
      y: e.clientY
    });
  };
  const renderTeamMember = (member: typeof team[0], i: number) => {
    const finalPos = finalPositions[i];
    const hasBeenDragged = finalPos.x !== 0 || finalPos.y !== 0;
    const parallaxOffset = !hasBeenDragged && !window.matchMedia("(prefers-reduced-motion: reduce)").matches ? scrollY * member.parallaxFactor : 0;
    const isDragging = draggedIndex === i;
    const translateX = finalPos.x + (isDragging ? dragOffset.x : 0);
    const translateY = finalPos.y + (isDragging ? dragOffset.y : 0) + parallaxOffset;
    return <div key={member.id} data-index={i} className={`group relative select-none ${isDragging ? "cursor-grabbing z-50" : "cursor-grab"}`} style={{
      transform: `translate(${translateX}px, ${translateY}px)`,
      transition: isDragging ? "none" : "transform 0.3s ease-out",
      willChange: isDragging ? "transform" : "auto"
    }} onMouseDown={e => handleMouseDown(i, e)}>
        <div className="relative w-[300px] h-[300px] rounded-full overflow-hidden bg-muted-dark-background shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:-translate-y-1.5 group-hover:shadow-[0_12px_40px_rgb(0_0_0_/_0.24),0_6px_16px_rgb(0_0_0_/_0.12)]">
          <img src={member.image} alt={`${member.name} - ${member.role}`} className="w-full h-full object-cover pointer-events-none" draggable="false" />

          <div className="absolute inset-x-0 bottom-0 bg-primary/90 backdrop-blur-sm text-center py-4 px-4 opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)]">
            <p className="font-display text-lg font-semibold text-slate-900">
              {member.name}
            </p>
            <p className="text-sm text-slate-900/90">{member.role}</p>
          </div>
        </div>
      </div>;
  };
  return <section ref={ref} className="relative py-24 bg-dark-background text-foreground-dark overflow-hidden">
      <div className="container mx-auto px-6">
        <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-center mb-16 text-white">
            Meet the Team
          </h2>

          <div className="flex flex-col items-center gap-16">
            {}
            <div className="flex justify-center items-center">
              {renderTeamMember(team[0], 0)}
            </div>

            {}
            <div className="flex justify-center items-center gap-16 md:gap-24 lg:gap-32">
              {renderTeamMember(team[1], 1)}
              {renderTeamMember(team[2], 2)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}